/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getChoiceIconStyle from "assets/getChoiceIconStyle";

const Dairy = ({ isActive = false }) => {
  const fill = getChoiceIconStyle(isActive);

  return (
    <svg
      width="48"
      height="47"
      viewBox="0 0 48 47"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.09216 13.5148C8.09216 12.9883 8.51897 12.5615 9.04546 12.5615H24.3302V14.4681H9.99876V43.7446C9.99876 43.9873 10.0951 44.22 10.2667 44.3915C10.4383 44.5631 10.671 44.6595 10.9136 44.6595H28.9813V13.5148H30.8879V45.6128C30.8879 46.1393 30.4611 46.5661 29.9346 46.5661H10.9136C10.1653 46.5661 9.44767 46.2688 8.91854 45.7397C8.38941 45.2106 8.09216 44.4929 8.09216 43.7446V13.5148Z" />
      <path d="M36.6235 13.775L32.8496 7.37575L34.4919 6.40723L38.398 13.0306C38.4845 13.1773 38.5301 13.3445 38.5301 13.5149V43.7447C38.5301 44.493 38.2329 45.2106 37.7037 45.7397C37.1746 46.2689 36.457 46.5661 35.7087 46.5661H29.9344V44.6595H35.7087C35.9513 44.6595 36.184 44.5631 36.3556 44.3916C36.5271 44.22 36.6235 43.9873 36.6235 43.7447V13.775Z" />
      <path d="M11.9515 6.4234C12.1205 6.12379 12.4378 5.93848 12.7818 5.93848H28.0665V7.84508H13.3385L9.87582 13.9835L8.21521 13.0468L11.9515 6.4234Z" />
      <path d="M14.6481 3.08922C14.4055 3.08922 14.1728 3.1856 14.0012 3.35716C13.8296 3.52872 13.7333 3.76142 13.7333 4.00405V6.89117H11.8267V4.00405C11.8267 3.25577 12.1239 2.53812 12.653 2.00899C13.1822 1.47987 13.8998 1.18262 14.6481 1.18262H31.801C32.5492 1.18262 33.2669 1.47987 33.796 2.00899C34.3252 2.53812 34.6224 3.25577 34.6224 4.00405V6.89117C34.6224 7.05528 34.58 7.21661 34.4994 7.35955L30.7631 13.9829L29.1025 13.0462L32.7158 6.64083V4.00405C32.7158 3.76142 32.6194 3.52872 32.4479 3.35716C32.2763 3.1856 32.0436 3.08922 31.801 3.08922H14.6481Z" />
    </svg>
  );
};

export default Dairy;
